<template>
  <div>
    Client management
  </div>
</template>
<script>
  export default {
    name: 'client-management-logs',
  }
</script>
<style>
</style>
